import VillageCardRoot from './Root';
import VillageCardOptions from './Options';
import VillageCardLoader from './Loader';

const VillageCard = {
  Root: VillageCardRoot,
  Options: VillageCardOptions,
  Loader: VillageCardLoader,
};

export default VillageCard;
